export default __webpack_public_path__ + "static/media/refresh.6f9c5187.svg";